import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Stack, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../utils/cloudinary-utils'

export const TestimonialsItem = ({
    starRating,
    headlineText,
    headlineFontFamily,
    headlineFontWeight,
    headlineFontStyle,
    headlineTextDecoration,
    headlineFontColor,
    headlineTag,
    bodyCopyText,
    bodyCopyFontFamily,
    bodyCopyFontWeight,
    bodyCopyFontStyle,
    bodyCopyTextDecoration,
    BodyFontColor,
    bodyCopyTag,
    reviewerName,
    reviewerNameFontFamily,
    reviewerNameFontColor,
    reviewerNameTag,
    totalItems
}) => {
    if (!headlineText && !bodyCopyText) {
        return null
    }

    headlineFontColor = headlineFontColor ? headlineFontColor : 'black'
    BodyFontColor = BodyFontColor ? BodyFontColor : 'black'
    reviewerNameFontColor = reviewerNameFontColor ? reviewerNameFontColor : 'black'

    const starRatings = []

    for (let i = 0; i < 5; i++) {
        if (i < starRating) {
            starRatings.push(
                <Image
                    alt="start rating filled"
                    src={getUrl('UIImages/images/starRatingFilled.svg')}
                    width="30px"
                    height="30px"
                />
            )
        } else {
            starRatings.push(
                <Image
                    alt="start rating"
                    src={getUrl('UIImages/images/starRating.svg')}
                    width="30px"
                    height="30px"
                />
            )
        }
    }

    return (
        <Box
            flex="1 1 0"
            gap="40px"
            maxWidth={totalItems > 1 ? '570px' : '650px'}
            textAlign="center"
        >
            <Stack
                align="start"
                flexDirection="row"
                justify="center"
                spacing="0px"
                marginBottom="20px"
            >
                {starRatings}
            </Stack>

            <Text
                as={headlineTag}
                fontSize={{base: '32px', lg: '34px'}}
                fontFamily={headlineFontFamily}
                fontWeight={headlineFontWeight}
                fontStyle={headlineFontStyle}
                textDecoration={headlineTextDecoration}
                textUnderlineOffset="4px"
                textColor={headlineFontColor}
                marginBottom="10px"
            >
                <Text fontFamily="cormorant" fontSize={{base: '32px', lg: '34px'}} as="span">
                    “
                </Text>
                {headlineText}
                <Text fontFamily="cormorant" fontSize={{base: '32px', lg: '34px'}} as="span">
                    ”
                </Text>
            </Text>
            <Text
                as={bodyCopyTag}
                fontSize={{base: '17px', lg: '14px'}}
                fontFamily={bodyCopyFontFamily}
                fontWeight={bodyCopyFontWeight}
                fontStyle={bodyCopyFontStyle}
                textDecoration={bodyCopyTextDecoration}
                textUnderlineOffset="4px"
                textColor={BodyFontColor}
                marginBottom="20px"
            >
                {bodyCopyText}
            </Text>
            {reviewerName && (
                <Text
                    as={reviewerNameTag}
                    fontSize="17px"
                    fontStyle="italic"
                    fontWeight="300"
                    lineHeight="26px"
                    letterSpacing="0.085px"
                    fontFamily={reviewerNameFontFamily}
                    textColor={reviewerNameFontColor}
                >
                    - {reviewerName}
                </Text>
            )}
        </Box>
    )
}

TestimonialsItem.propTypes = {
    starRating: PropTypes.string,
    headlineText: PropTypes.string,
    headlineFontFamily: PropTypes.string,
    headlineFontWeight: PropTypes.string,
    headlineFontStyle: PropTypes.string,
    headlineTextDecoration: PropTypes.string,
    headlineFontColor: PropTypes.string,
    headlineTag: PropTypes.string,
    bodyCopyText: PropTypes.string,
    bodyCopyFontFamily: PropTypes.string,
    bodyCopyFontWeight: PropTypes.string,
    bodyCopyFontStyle: PropTypes.string,
    bodyCopyTextDecoration: PropTypes.string,
    BodyFontColor: PropTypes.string,
    bodyCopyTag: PropTypes.string,
    reviewerName: PropTypes.string,
    reviewerNameFontFamily: PropTypes.string,
    reviewerNameFontColor: PropTypes.string,
    reviewerNameTag: PropTypes.string,
    totalItems: PropTypes.number
}

export default TestimonialsItem
